import React from 'react';
import {useTranslation} from 'react-i18next';

import {LightExclamationIcon} from 'components/common/icons';
import Button, {ButtonStyles} from 'components/common/Form/Button';

import styles from './HeaderMessage.module.scss';

const HeaderMessage = ({onGotIt}) => {
    const {t} = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.messageWrapper}>
                <LightExclamationIcon />
                <span className={styles.submissionText}>{t(`page.submissionSentToAdmin`)}</span>
            </div>

            <Button
                btnStyle={ButtonStyles.default}
                text={t(`page.gotIt`)}
                className={styles.button}
                onClick={onGotIt}
            />
        </div>
    );
};

export default HeaderMessage;
